module.exports = __webpack_public_path__ + "img/jliwu.fdb1471d.gif";